import React from 'react';

import { ReactComponent as UserGroupIcon } from 'assets/icons/userGroup.svg';

import './RoleBadge.scss';

interface Props {
  color: string;
}

const RoleBadge: React.FC<Props> = ({ color }) => {
  return (
    <div className="roleBadge" style={{ backgroundColor: color }}>
      <UserGroupIcon />
    </div>
  );
};

export default RoleBadge;
